module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/launcher_meetings_new2.9fa71945172e1585663594bc17a4a301.svg";